import { render, staticRenderFns } from "./FrontendFooter.vue?vue&type=template&id=1b526166&"
import script from "./FrontendFooter.vue?vue&type=script&lang=js&"
export * from "./FrontendFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports